/*
  Additional visuals need to also add an entry in the Panel.component file so
  it knows which component to render.
  
  We can't add them here or will get circular dependency issues

*/
const nodeYSpace = 350;
export default {
  plot: {
    height: 3840,
    width: 2160,
    nodeXSpace: 800,
    nodeYSpace: 350,
  },
  nodes: {
    9569897: { // Node 1
      x: 250,
      y: 3650,
    },
    9570307: { // Node 2
      x: 250,
      y: 3650 - nodeYSpace,
    },
    9569775: { // Node 3
      x: 250,
      y: 3650 - (nodeYSpace * 2),
    },
    8422665: { // This is actually the weather station gateway
      x: 1400,
      y: 3650,
    }
  },
  sensors: {
    nameMap: {
      // We rename some of the inconsistent sensor key names used in the reducer
      // Have to check catalog to ensure they give same units before using this
      temp_out: 'temp_last', 
      hum_out: 'hum_last',
      wind_dir_last_deg: 'wind_dir',
      wind_speed_last: 'wind_speed',
      thsw_index: 'wet_bulb_last',
      solar_rad_last: 'solar_rad',
    },
    temp: {
      max: 50,
      min: 10,
    },
    globeTemp: {
      max: 75,
      min: 10,
    },
  },
  pollInterval: 10 * 60 * 60 * 1000, // 10 Minutes. Lambda/Firebase caches 5 mins
  cycleInterval: 15 * 1000,
  visuals: {
    temperatureText: {
      title: 'Current temperature',
    },
    humidity: {
      title: 'Humidity',
    },
    windspeed: {
      title: 'Anemometer',
    },
    windspeedField: {
      title: 'Windspeed Field'
    },
    dewPoint: {
      title: 'Dew Point Last',
    },
    solarRadiation: {
      title: 'Solar Radiation',
    },
    nodes: {
      title: 'Nodes',
    },
    tempHum: {
      title: 'Temperature & Humidity 2'
    },
    tempHumText: {
      title: 'Temperature & Humidity 1'
    },
    scrolling: {
      title: '',
    },
  }
}



// WEBPACK FOOTER //
// ./src/config/index.js